
import { Button } from "@/components/ui/button";
import { MessageSquarePlus } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTranslation } from 'react-i18next';

interface ContactFormProps {
  buttonText?: string;
  formNote?: string;
  className?: string;
}

export const ContactForm = ({
  buttonText,
  formNote,
  className,
}: ContactFormProps) => {
  const { t } = useTranslation();
  // GoogleフォームURL
  const googleFormUrl =
    "https://docs.google.com/forms/d/e/1FAIpQLSfGctjmssSGu73JcGfPeECrLstNGZF5w_36ePFOZLw7s-1HPg/viewform";

  const openFormInNewTab = () => {
    window.open(googleFormUrl, "_blank", "noopener,noreferrer");
  };

  const displayButtonText = buttonText ?? t('contact.default_button_text');
  const displayFormNote = formNote ?? t('contact.default_form_note');

  return (
    <div className={cn("w-full max-w-2xl mx-auto", className)}>
      <Button
        size="lg"
        className="w-full font-bold py-4 px-8 text-lg bg-blue-600 hover:bg-blue-700 text-white"
        onClick={openFormInNewTab}
      >
        <MessageSquarePlus className="mr-2 h-5 w-5" />
        {displayButtonText}
      </Button>
      <div className="text-center text-sm text-gray-500 mt-4">
        {displayFormNote.split('\n').map((line, i) => (
          <span key={i}>{line}{i < displayFormNote.split('\n').length - 1 && <br />}</span>
        ))}
      </div>
    </div>
  );
};
